import { create } from 'zustand'
import { devtools } from 'utils/devtools'

type DebugModalEntry = {
  key: string
  label: string
}

type DebugPanelState = {
  registered: Record<string, DebugModalEntry>
  openKey: string | null
  minimizedKey: string | null
}

type DebugPanelActions = {
  register: (key: string, label: string) => void
  unregister: (key: string) => void
  open: (key: string) => void
  close: () => void
  minimize: () => void
  restore: () => void
}

export const useDebugPanelStore = create<DebugPanelState & DebugPanelActions>()(
  devtools(
    (set) => ({
      registered: {},
      openKey: null,
      minimizedKey: null,
      register: (key, label) =>
        set((s) => ({
          registered: { ...s.registered, [key]: { key, label } },
        })),
      unregister: (key) =>
        set((s) => {
          const { [key]: _, ...rest } = s.registered
          return {
            registered: rest,
            openKey: s.openKey === key ? null : s.openKey,
          }
        }),
      open: (key) => set({ openKey: key, minimizedKey: null }),
      close: () => set({ openKey: null }),
      minimize: () => set((s) => ({ minimizedKey: s.openKey, openKey: null })),
      restore: () =>
        set((s) => ({ openKey: s.minimizedKey, minimizedKey: null })),
    }),
    { name: 'debug-panel' }
  )
)

export const useRegisteredDebugModals = () =>
  useDebugPanelStore((s) => Object.values(s.registered))
